// extracted by mini-css-extract-plugin
export default {"name":"Product_name__yEA67","image":"Product_image__dJL2Q","addToCart":"Product_addToCart__8VAqB","imageContainer":"Product_imageContainer__bTkRx"};